import React from 'react';
import FooterBreadCrumb from '../../components/common-footer/FooterBreadCrumb';

const RefusalOfUnauthorized = () => {
    // Desktop View
    return (
        <div className="privacy-policy announcement-list-page">
            <div className="privacy-policy-page">

                {/* Main Content */}
                <main className="main-content">

                    {/* Breadcrumb */}
                    <FooterBreadCrumb heading="이메일무단수집거부" />

                    <div className="content-container">
                      <div className="outer-box">

                        <div className="privacy-text">
                            <h2>이메일무단수집거부</h2>
                            <p>
                                회원에게 무차별적으로 보내지는 타사의 메일을 차단하기 위해, 본 웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망법 제50조에 의거 형사 처벌됨을 유념하시기 바랍니다.
                            </p>

                            <h2>정보통신망법 제50조의2 (전자우편 주소의 무단수집행위 금지)</h2>
                            <p>
                                ① 누구든지 전자우편주소의 수집을 거부하는 의사가 명시된 인터넷 홈페이지에서 자동으로 전자우편 주소를 수집하는 프로그램 또는 그 밖의 기술적 장치를 이용하여 전자우편주소를
                                수집하여서는 안된다.<br />  
                                ② 누구든지 제1항의 규정을 위반하여 수집된 전자우편주소를 판매.유통 하여서는 안 된다.<br />
                                ③ 누구든지 제1항 및 제2항의 규정에 의하여 수집.판매 및 유통이 금지된 전자우편주소임을 알고 이를 정보 전송에 이용하여서는 안 된다.
                            </p>
                        </div>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    );
};

export default RefusalOfUnauthorized; 